/* eslint class-methods-use-this: "off" */
import * as React from 'react'
import styles from '@src/styles/login.page.styl'
import { Redirect } from 'react-router-dom'
import { HelpLink } from '../shell/components/help.link'
import cx from 'classnames'
import { AppStorage } from '@src/utils/storage.helpers'
import { storagePrefix } from '@src/constants/constants'
import { useEffect } from 'react'
import { useAuth } from '../oauth/context'
const storage = new AppStorage(storagePrefix, sessionStorage)

interface OwnProps {}
export type Props = OwnProps

const LoginPage: React.FC<Props> = (props: Props) => {
  const { getLoginUrl } = useAuth()

  useEffect(() => {
    if (!storage.get('userEmail')) {
      storage.purgeJunk()
    }
    window.location.replace(getLoginUrl())
  }, [])

  if (storage.get('userEmail')) {
    return <Redirect to={'/'} />
  }

  return (
    <div className={styles.loginPage}>
      <div className={styles.header}>
        <div className={styles.logo} />
        <div className={styles.right}>
          <HelpLink className={cx(styles.circleWrapper, styles.helplink)} />
        </div>
      </div>
    </div>
  )
}

export default LoginPage
